import './App.css';
import AdventCalendar from './AdventCalendar';

function App() {
  return (
    <div className="App">
      <AdventCalendar />
    </div>
  );
}

export default App;
